import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Breadcrumbs": Breadcrumbs, "@mui/material/Link": Link, "@mui/material/Menu": Menu, "@mui/material/MenuItem": MenuItem, "@mui/material/IconButton": IconButton, "@mui/icons-material/MoreHoriz": MoreHorizIcon } } });
export default ClientProvider;
